import { Volume } from '~/shared/types/api';
import { toaster } from '~/shared/utils/toaster';
import { SelectOption } from '~/shared/utils/types';

import { DatafySwitchContextType } from '../DatafySwitchProvider';

export const baseUrl = `/api/v1/volumes`;

export const canBeDatafied = (v: Volume) => v.isDatafiable;

export const canBeUnDatafied = (v: Volume) =>
    v.isUnDatafiable && ['Managed', 'Migrating'].includes(v?.monitoring || '');

export const isSwitchedOn = (v: Volume) =>
  ['Migrating', 'Growing', 'Shrinking', 'Merging', 'Managed'].includes(v?.monitoring || '');

export const isSwitchDisabled = (v: Volume) =>
  (!canBeDatafied(v) && !canBeUnDatafied(v)) ||
  (isSwitchedOn(v) && v.monitoring !== 'Managed' && v.monitoring !== 'Migrating');

export function getApiFilterFromSelectOption(f: SelectOption) {
  return JSON.stringify({
    field: f.group,
    value: f.id,
    op: 'equals',
  });
}

export function datafyErrorToast(
  volumeId: Volume['volumeId'],
  event: DatafySwitchContextType['datafySwitchVolumes'][number]['state']
) {
  return toaster({
    variant: 'error',
    title: `${event === 'datafying' ? 'Datafication' : 'Undatafication'} Error`,
    message: `Volume ${volumeId} has failed to ${event === 'datafying' ? 'Datafy' : 'Undatafy'}.`,
    toastId: volumeId,
  });
}

export const optmisticSwitchingInterval = 20000;
